import DashLayout from "@/layouts/DashLayout";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import PageTitle from "@/components/PageTitle";
import Spinner from "@/components/Spinner";
import { useAppSelector } from "@/redux/features/hooks";
import { Roles } from "@/redux/services/user/user.type";
import SessionsList from "@/components/pos/register/SessionsList";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SessionsPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);

  return (
    <DashLayout>
      <RoleProtectedPage
        allowedRoles={[Roles.manager, Roles.cashier]}
        allowedPermissions={["cash_register.view"]}
      >
        <div className="space-y-4">
          <Link
            to="/register"
            className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-card-foreground"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour à la caisse
          </Link>
          <PageTitle
            title="Historique des caisses"
            description="Historique des sessions de caisse"
          />
          {restaurant ? (
            <SessionsList restaurantId={restaurant.id} />
          ) : (
            <div className="flex items-center justify-center py-12">
              <Spinner />
            </div>
          )}
        </div>
      </RoleProtectedPage>
    </DashLayout>
  );
};

export default SessionsPage;
